import { put } from 'redux-saga/effects';
import { authenticate } from 'auth/actions';
import { find as findPurchase } from 'billing/purchases/actions';
import { unpaidPurchase } from 'app/routes';

export function* unpaidPurchaseNavigate({ purchaseId }) {
  yield put(authenticate(unpaidPurchase(purchaseId)));
  yield put(findPurchase(purchaseId));
}
